import type { RootState } from '../store';
import { WorkflowsState } from './types';

export const getWorkflows = (state: RootState): WorkflowsState => {
  return state.workflows || [];
};
